import React from 'react';
import { connect } from 'react-redux';

import { goTo } from '../tools';

class IngresaCorreo extends React.Component {
	ir = (sRuta) => {
		goTo(sRuta);
	}
	render() {
		return <div className="login-box">
			<div className="login-form">
				<h3>Cambio exitoso</h3>
				<div className="text-center mt-34">
					<img src={ require("../img/vector-ok.png") } alt="" />
					<div className="mt-25 texto-17">
						<p>Tu contraseña fue cambiada con éxito.</p>
					</div>
				</div>
			</div>
			<div className="text-center aceptar-cancelar-btn">
				<a onClick={this.ir.bind(this, "login")}>Cancelar</a>
				<a onClick={this.ir.bind(this, "lgin")} className="orange-text">Aceptar</a>
			</div>
		</div>
	}
}

export default connect(null, null)(IngresaCorreo);


// WEBPACK FOOTER //
// ./src/modificar/cambioExitoso.cmpt.js